import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Button from "../component/Partial/Button";
import DeleteIcon from "../assets/Icons/DeleteIcon";
import EditIcon from "../assets/Icons/EditIcon";
import { useNavigate, Outlet, Link, NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteUserApiCall,
  generatePasswordApicall,
} from "../store/actions/projectAction";
import CreateUserModal from "../component/Admin/CreateUserModal";
import SuccessModal from "../component/Admin/SuccessModal";
import UserTable from "../component/Admin/UserTable";
import ProjectTable from "../component/Admin/ProjectTable";

const projects = [
  {
    date: "30/04/2024 05:30 PM",
    projectName: "Marketing Sample",
    clientName: "Lumiq",
    clientPhone: "123",
    pincode: "123",
    notes: "With Lumiq icon",
    token: "6v73su",
    password: "4c8ntyj8",
  },
  {
    date: "13/04/2024 03:36 PM",
    projectName: "Burj View remaining panel",
    clientName: "Vexus",
    clientPhone: "1234567890",
    pincode: "123456",
    notes: "without xeon icon",
    token: "rlazlq",
    password: "5iok2bj3",
  },
  {
    date: "11/04/2024 03:03 PM",
    projectName: "lytiva",
    clientName: "lytiva",
    clientPhone: "1234567890",
    pincode: "123456",
    notes: "without xeon icon",
    token: "bz1swd",
    password: "q1q6n6rv",
  },
  {
    date: "08/03/2024 09:40 PM",
    projectName: "Burj View",
    clientName: "Vexus",
    clientPhone: "1234567890",
    pincode: "123456",
    notes: "Loft Icon",
    token: "4i578l",
    password: "4sx2usgx",
  },
  {
    date: "15/07/2023 04:39 PM",
    projectName: "Project3",
    clientName: "Inoxbee Smart Projects",
    clientPhone: "9998331283",
    pincode: "380051",
    notes: "with Inoxbee BLE Module",
    token: "qrn5o3",
    password: "eaj22ue",
  },
  // Add more project data as needed
];

const data = [
  // {
  //   id: 3,
  //   label: "Dashboard",
  //   value: "dashboard",
  //   href: "dashboard",
  // },
  {
    id: 1,
    label: "Projects",
    value: "project",
    href: "projects",
  },
  {
    id: 2,
    label: "Users",
    value: "user",
    href: "users",
  },
  {
    id: 3,
    label: "Profile",
    value: "profile",
    href: "profile",
  },
];
function Admin() {
  const [selected, setSelected] = useState(1);

  const users = useSelector((state) => state.project.users);

  const [isModalOpen, setModalOpen] = useState(false);
  const [userData, setUserData] = useState();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const toggleModal = () => {
    setModalOpen((prev) => !prev);
  };

  const handleDelete = (id) => {
    dispatch(deleteUserApiCall(id));
  };

  const handleGeneratePassword = (id) => {
    dispatch(generatePasswordApicall(id)).then((result) => {
      if (result?.payload?.success) {
        setUserData(result?.payload?.user);
      }
    });
  };

  return (
    <div className="flex flex-col">
      <Header />

      <div className="mt-24 w-full flex">
        <div
          className="w-[200px]"
          style={{
            height: "calc(100vh - 4rem)",
            boxShadow: "0 0 5px #CCC",
          }}
        >
          <div className="mt-4">
            {data?.map((item, index) => {
              // const isActive = selected == item?.id;

              return (
                <NavLink
                  className={({ isActive }) =>
                    `text-center flex justify-center text-sm py-3 cursor-pointer hover:bg-[#EEE] ${
                      isActive ? "bg-[#EEE]" : ""
                    }`
                  }
                  key={index}
                  onClick={() => setSelected(item?.id)}
                  to={item.href}
                >
                  {item.label}
                </NavLink>
              );
            })}
          </div>
        </div>

        <Outlet />
        {/* {selected == 1 && <ProjectTable />}
        {selected == 2 && <UserTable />} */}
      </div>

      {isModalOpen && (
        <CreateUserModal
          userData={userData}
          setUserData={setUserData}
          onClose={toggleModal}
        />
      )}

      {userData && (
        <SuccessModal userData={userData} onClose={() => setUserData(null)} />
      )}
    </div>
  );
}

export default Admin;
